import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { notifyOpener } from "./oauthPopupBridge";
import linkedInUtils from "../settings/ConnectedAccounts/LinkedInAccounts/common/linkedInUtils";

// Dedicated callback route (registered in Routes/ConnectApps.js) so the popup
// only ever lands here for this purpose - unlike detecting "am I the popup"
// from window.name/window.opener after the trip through LinkedIn/Unipile
// (both get cleared by the browser along the way), simply reaching this URL
// is proof enough. No detection needed, matching how OutlookOauth/SalesForceOauth
// etc. already handle their own OAuth callbacks in this same folder.
const LinkedInOAuthCallback = () => {
  useEffect(() => {
    (async () => {
      // Unipile appends account_id to this URL only on an actual successful
      // login - its presence is what tells the backend this was a real
      // attempt, not just an abandoned popup.
      const accountId = new URLSearchParams(window.location.search).get(
        "account_id"
      );
      if (accountId) {
        await linkedInUtils.markOAuthConnectionStarted(accountId);
      }
      notifyOpener({ type: "LINKEDIN_OAUTH_POPUP_DONE" });
    })();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          <div>Connecting your LinkedIn account…</div>
        </div>
      </div>
    </div>
  );
};

export default observer(LinkedInOAuthCallback);
export { LinkedInOAuthCallback };
